import normalizeZipCode from "app/pages/sales-intelligence/common-components/zip-codes/utils/normalizeZipCode";

const parseZipCodesValues = (value: string): string[] =>
    value
        .trim()
        .split(/[\n,]/)
        .map((code) => normalizeZipCode(code.trim()))
        .filter(Boolean);

export default parseZipCodesValues;
